import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box } from "@mui/material";
import { storeEpAlerts } from "@smp/utils";
import { IconExclamationMark } from "@tabler/icons-react";
import clsx from "clsx";
import { useCallback, useMemo, useState } from "react";
import { UiButton } from "../ui_button";
import { UiCheckboxV2 } from "../ui_checkbox_v2";
import { UiFormControlLabel } from "../ui_form_control_label";
import { UiGrid } from "../ui_grid";
import { UiTypography } from "../ui_typography";
import { useStyles } from "./ui_alert.css";
export const UiAlert = ({ title, align = "left", button, children, className, fullHeight, fullWidth, gutterBottom, onClick, variant = "info", storeEpKey, display = "flex", rememberLabel, hideIcon, }) => {
    const classes = useStyles({ align, gutterBottom, variant, hideIcon });
    const [isVisible, setVisible] = useState(!storeEpKey || !storeEpAlerts.get(storeEpKey));
    const [isRemember, setRemember] = useState(false);
    const handleClose = useCallback(() => {
        if (onClick) {
            onClick();
        }
        else if (storeEpKey) {
            if (isRemember) {
                storeEpAlerts.set(storeEpKey, Date.now());
            }
            setVisible(false);
        }
    }, [isRemember, onClick, storeEpKey]);
    const handleToggleRemember = useCallback(() => {
        setRemember((state) => !state);
    }, []);
    return useMemo(() => {
        if (!isVisible) {
            return null;
        }
        return (_jsxs(Box, { className: clsx(className, classes.ui_alert, {
                [classes.ui_alert__full_height]: fullHeight,
                [classes.ui_alert__full_width]: fullWidth,
                [classes.ui_alert__variant_error]: variant === "error",
                [classes.ui_alert__variant_info]: variant === "info",
                [classes.ui_alert__variant_warning]: variant === "warning",
            }), display: display, flexDirection: "column", textAlign: align, children: [!hideIcon && (_jsx("div", { className: classes.icon, children: _jsx(IconExclamationMark, {}) })), title && (_jsx(UiTypography, { className: classes.title, children: title })), children && _jsx("div", { className: classes.content, children: children }), button && (_jsx(Box, { ml: "auto", children: _jsx(UiButton, { variant: "text", onClick: onClick, size: "small", children: button }) })), storeEpKey && rememberLabel && (_jsxs(UiGrid, { container: true, className: classes.rememberLabel, children: [_jsx(UiGrid, { item: true, xs: true, children: _jsx(UiFormControlLabel, { className: classes.ui_alert__checkboxLabel, classes: {
                                    label: classes.ui_alert__checkboxLabel__text,
                                }, control: _jsx(UiCheckboxV2, { color: "primary", checked: isRemember, onClick: handleToggleRemember }), label: rememberLabel }) }), _jsx(UiGrid, { item: true, children: _jsx(UiButton, { color: {
                                    error: "secondary",
                                    info: "primary",
                                }[variant] || undefined, onClick: handleClose, className: classes.rememberLabel__btn, children: button || "OK" }) })] }))] }));
    }, [
        isVisible,
        className,
        classes.ui_alert,
        classes.ui_alert__full_height,
        classes.ui_alert__full_width,
        classes.ui_alert__variant_error,
        classes.ui_alert__variant_info,
        classes.ui_alert__variant_warning,
        classes.icon,
        classes.title,
        classes.content,
        classes.rememberLabel,
        classes.ui_alert__checkboxLabel,
        classes.ui_alert__checkboxLabel__text,
        classes.rememberLabel__btn,
        fullHeight,
        fullWidth,
        variant,
        display,
        align,
        hideIcon,
        title,
        children,
        button,
        onClick,
        storeEpKey,
        rememberLabel,
        isRemember,
        handleToggleRemember,
        handleClose,
    ]);
};
//# sourceMappingURL=ui_alert.js.map